import React, { useMemo, useState } from "react";
import Button from "./basic/Button";
import { T } from "../hooks/useLanguage";
import "../styles/email-login-diagnostics.scss";
import {
  classifyEmailLoginError,
  formatEmailLoginDiagnosticsForSupport,
  getAxiosErrorDetails,
  getLatestEmailLoginDiagnostic,
} from "../services/emailLoginDiagnostics";

const copyTextToClipboard = async (text) => {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (_error) {
      // Fall back to execCommand below.
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "readonly");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

export default function EmailLoginDiagnosticsPanel({
  error = null,
  titleKey = "verify.invalidcodetitle",
  hintKey = "verify.invalidcodehint",
}) {
  const [copied, setCopied] = useState(false);

  const details = useMemo(() => getAxiosErrorDetails(error), [error]);
  const latestDiagnostic = useMemo(() => getLatestEmailLoginDiagnostic(), []);
  const reason = useMemo(() => classifyEmailLoginError(error), [error]);

  const handleCopySupportInfo = async () => {
    await copyTextToClipboard(formatEmailLoginDiagnosticsForSupport());
    setCopied(true);
  };

  return (
    <div className="email-login-diagnostics" role="alert">
      <p className="email-login-diagnostics__title">
        <T>{titleKey}</T>
      </p>
      <p>
        <T>{hintKey}</T>
      </p>
      {details?.message ? (
        <small>
          <T>verify.errordetail</T>: {details.message}
        </small>
      ) : null}
      {details?.httpStatus ? (
        <small>HTTP {details.httpStatus}</small>
      ) : null}
      {reason && reason !== "unknown" ? (
        <small>
          <T>verify.errorreason</T>: {reason}
        </small>
      ) : null}
      {latestDiagnostic?.id ? (
        <small>
          <T>verify.supportreference</T>: {latestDiagnostic.id}
        </small>
      ) : null}
      <Button onClick={handleCopySupportInfo} as="text">
        <T>{copied ? "verify.copiedsupportinfo" : "verify.copysupportinfo"}</T>
      </Button>
    </div>
  );
}
